import { PropsWithChildren } from 'react';
import * as React from 'react';
import { useLocation } from 'react-router-dom';

export interface StandaloneCheckerProps extends PropsWithChildren {
  standalones: {
    path: string;
    Comp: React.ComponentType;
  }[];
}

function StandaloneChecker({ standalones, children = null }: StandaloneCheckerProps) {
  const location = useLocation();
  const found = standalones.find((s) => s.path === location.pathname);
  if (found) {
    return <found.Comp />;
  }
  return children;
}

export default StandaloneChecker;
